import { render, staticRenderFns } from "./SiteList.vue?vue&type=template&id=5b4d6c24&scoped=true"
import script from "./SiteList.vue?vue&type=script&lang=js"
export * from "./SiteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d6c24",
  null
  
)

export default component.exports